<div *ngIf="categoryAvailableReservations && categoryAvailableReservations.availableReservations" class="overflow-set">
    <div class="row">
        <div *ngFor="let availableReservation of categoryAvailableReservations.availableReservations; let i = index"
            class="col-4 col-md-4 col-lg-6">
            <button *ngIf="i == availableReservationIdx" class="btn btn-primary btn-block mb-1 " style="width: 100%">
                {{ availableReservation.reservationTime | date:'HH:mm' }}
            </button>
            <button *ngIf="i != availableReservationIdx" class="btn btn-outline-primary btn-block mb-1 "
                style="width: 100%" (click)="selectReservationTime(i)">
                {{ availableReservation.reservationTime | date:'HH:mm' }}
            </button>
        </div>
    </div>
    <div *ngIf="!checkIfAnyReservationAvailable()" class="overflow-set">
        <div class="text-danger">{{ 'no-reservations' | translate }}</div>
    </div>
</div>

<div class="mt-4 text-danger text-large" *ngIf="bookedReservationCounter">
    {{ 'initially-reserved' | translate }}: {{ bookedReservationCounter | date: 'mm:ss' }}
</div>
